class InfosVariant extends HTMLElement {
    constructor() {
        super();
        this.hoverElement = null;
        this.infoElement = null;
    }

    connectedCallback() {
        this.hoverElement = this.querySelector(".infos-variant--hover");
        this.infoElement = this.querySelector(".infos-variant--infos");

        if (this.isDesktop()) {
            this.hoverElement.addEventListener("mouseenter", this.showInfo.bind(this));
            this.hoverElement.addEventListener("mouseleave", this.hideInfo.bind(this));
        }
    }

    isDesktop() {
        return window.matchMedia("(min-width: 768px)").matches;
    }

    showInfo() {
        this.infoElement.classList.remove("hidden");
    }

    hideInfo() {
        this.infoElement.classList.add("hidden");
    }
}

customElements.define("w3-infos-variant", InfosVariant);

if (window.matchMedia("(max-width:768px)").matches) {
    function updateInfosTaille() {
        const radios = document.querySelectorAll(".block-swatch__radio");

        radios.forEach((radio) => {
            if (radio.checked) {
                const infosTaille = radio.getAttribute("infostaille");
                const infosColor = radio.getAttribute("infoscolor");
                const infosLabel = radio.getAttribute("infoslabel");
                const infosTailleMobile = document.querySelector(".infos-taille-mobile");

                let displayContent = "";
                
                if (infosTaille) {
                    displayContent += `<span style="color: ${infosColor};">(${infosTaille})</span>`;
                }

                if (displayContent) {
                    infosTailleMobile.innerHTML = displayContent;
                    infosTailleMobile.classList.remove("hidden");
                } else {
                    infosTailleMobile.classList.add("hidden");
                }
            }
        });
    }

    const radios = document.querySelectorAll(".block-swatch__radio");
    radios.forEach((radio) => {
        radio.addEventListener("click", updateInfosTaille);
    });

    updateInfosTaille();
}
